export const API_URL_STORAGE_KEY = "API_URL_OVERRIDE";

export const API_ENVS = [
  {
    label: "local",
    url: "http://localhost:8081/api",
    backgroundColor: "#2e7d32",
  },
  {
    label: "develop",
    url: "https://dragon-api.vidletdev.io/api",
    backgroundColor: "#0277bd",
  },
  {
    label: "stage",
    url: "https://dragon-api.vidletstage.io/api",
    backgroundColor: "#f9a825",
  },
  {
    label: "prod",
    url: "https://dragon-api.vidlet.io/api",
    backgroundColor: "#ff1744",
  },
] as const;

export type ApiEnvUrl = (typeof API_ENVS)[number]["url"];

export const LOCAL_API_URL: ApiEnvUrl = API_ENVS[0].url;

export function getActiveApiUrl(): string {
  try {
    const fromLocal = localStorage.getItem(API_URL_STORAGE_KEY);
    if (fromLocal) return fromLocal;

    // Migrate one-time from the old sessionStorage key.
    const fromSession = sessionStorage.getItem(API_URL_STORAGE_KEY);
    if (fromSession) {
      localStorage.setItem(API_URL_STORAGE_KEY, fromSession);
      sessionStorage.removeItem(API_URL_STORAGE_KEY);
      return fromSession;
    }
  } catch {
    // Ignore if storage is unavailable
  }

  if (typeof window !== "undefined" && window.location.protocol === "http:") {
    return LOCAL_API_URL;
  }

  return process.env.REACT_APP_API_URL || LOCAL_API_URL;
}

export function setActiveApiUrl(url: ApiEnvUrl): void {
  localStorage.setItem(API_URL_STORAGE_KEY, url);
}
